import { render, staticRenderFns } from "./humanResources.vue?vue&type=template&id=b4b28fda&scoped=true"
import script from "./humanResources.vue?vue&type=script&lang=js"
export * from "./humanResources.vue?vue&type=script&lang=js"
import style0 from "./humanResources.vue?vue&type=style&index=0&id=b4b28fda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b28fda",
  null
  
)

export default component.exports